export const ABOVE_THE_FOLD_COUNT = 4;
export const ALL = 'All';
export const DEFAULT_POPULAR_TOPICS = ['AI', 'Nvidia', 'OpenAI', 'Crypto', 'Microsoft'];
export const MAX_INITIAL_PAGE_COUNT = 10;
export const LOAD_MORE_BUTTON_TEXT = 'Load more';
export const SEARCH_INPUT_FIELD_NAME = 'query';
export const RESULTS_PER_PAGE = 20;

export const NO_RESULTS_IMAGE = 'https://tii.imgix.net/global/graphics/dis-charted.png';

export const PAYWALL_GRAPHICS = [
  {
    id: 'paywall-graphic-1',
    graphic: 'https://img.datawrapper.de/Khg8X/466c375e361acb299b14568db66dcb98/full.png',
    handleGraphicClick: () => void 0,
  },
  {
    id: 'paywall-graphic-2',
    graphic: 'https://img.datawrapper.de/RIO5I/57badafe82586c7656135f5a5ffa1eea/full.png',
    handleGraphicClick: () => void 0,
  },
];
